import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputSwitch, InputPicklist } from '../../components';
import BaseCopy from '../base/base-copy.component'; 
import Model from './menugroup-model';  //editable..
import OwnerPicklist from '../owner/owner-picklist.component';
import MenuChecklist from '../menu/menu-checklist.component';
import OwnerChecklist from '../owner/owner-checklist.component';
import UserChecklist from '../user/user-checklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class MenugroupCopy extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }
    
    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadMenu = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'menu': data || [], 'menuCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    }  

    private onLoadAccessOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'accessowner': data || [], 'accessownerCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    }  
   
    private onLoadUser = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'users': data || [], 'userCaption': data?.length > 0? data[0].name + (data.length>1? ', ...': '') : ''}  });
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseCopy history={this.props.history} 
                model={Model} datarow={this.state.datarow} onLoad={this.onLoad} onError={this.onError}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                } 
                <InputPicklist name='menu' label='Menu Access List' value={this.state.datarow.menu} caption={this.state.datarow.menuCaption} disableAutoClose clearValue={this.onLoadMenu} error={this.state.errors?.menu} onChange={this.onChange} >
                    <MenuChecklist history={this.props.history} currentId={this.state.datarow.menu} onLoad={this.onLoadMenu} disableBackButton/>
                </InputPicklist> 
                {AppService.isAppFullVersion() &&
                <InputPicklist name='accessowner' label='Owner Access List' value={this.state.datarow.accessowner} caption={this.state.datarow.accessownerCaption} disableAutoClose clearValue={this.onLoadAccessOwner} error={this.state.errors?.accessowner} onChange={this.onChange} >
                    <OwnerChecklist history={this.props.history} currentId={this.state.datarow.accessowner} onLoad={this.onLoadAccessOwner} disableBackButton/>
                </InputPicklist> 
                }
                <InputPicklist name='users' label='User Access List' value={this.state.datarow.users} caption={this.state.datarow.userCaption} disableAutoClose clearValue={this.onLoadUser} error={this.state.errors?.user} onChange={this.onChange} >
                    <UserChecklist history={this.props.history} currentId={this.state.datarow.users} onLoad={this.onLoadUser} disableBackButton/>
                </InputPicklist>
                <Input name='icon' label='Icon' value={this.state.datarow.icon} error={this.state.errors?.icon} onChange={this.onChange} />
                 
            </BaseCopy>
        );
    }
}